import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Proposal } from 'app/entities/proposal';
import { formatBRL } from 'app/helpers/money';

export interface ProposalRefuseDialogResult {
    date: Date;
    reason_type?: string;
    reason?: string;
}

/** Mesmos tipos de Proposal::REFUSED_REASON_TYPES na API */
export const REFUSED_REASONS = [
    { value: 'price', label: 'Preço' },
    { value: 'deadline', label: 'Prazo' },
    { value: 'other_supplier', label: 'Outro fornecedor' },
    { value: 'gave_up', label: 'Desistiu' },
    { value: 'other', label: 'Outro' },
];

/**
 * ORCA-1966: reprovar pela lista. Confirmação com motivo opcional (vai para os relatórios).
 */
@Component({
    selector: 'app-proposal-refuse-dialog',
    templateUrl: './proposal-refuse-dialog.component.html',
    styleUrls: ['./proposal-refuse-dialog.component.scss'],
})
export class ProposalRefuseDialogComponent {
    readonly reasons = REFUSED_REASONS;
    reasonType: string | null = null;
    reason = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { proposal: Proposal },
        private dialogRef: MatDialogRef<ProposalRefuseDialogComponent, ProposalRefuseDialogResult>,
    ) { }

    get proposal(): Proposal {
        return this.data.proposal;
    }

    get value(): string {
        return formatBRL(this.proposal?.totalLiquid);
    }

    pick(value: string): void {
        this.reasonType = this.reasonType === value ? null : value;
    }

    refuse(): void {
        const result: ProposalRefuseDialogResult = { date: new Date() };
        if (this.reasonType) {
            result.reason_type = this.reasonType;
        }
        if (this.reason.trim()) {
            result.reason = this.reason.trim();
        }
        this.dialogRef.close(result);
    }
}
